import actionTypes from "../common/actionTypes";

const authReducer = (state, action) => {
  switch (action.type) {
    case actionTypes.LOGIN:
      return {
        ...state,
        loading: true,
      };

    case actionTypes.LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case actionTypes.LOGOUT:
      return {
        ...state,
        user: null,
      };

    case actionTypes.INIT_CHANGE_STORE_PROCESS:
      return {
        ...state,
        loading: true,
      };

    case actionTypes.SET_USER_TO_STORE:
      return {
        ...state,
        user: action.payload.user,
        loading: false,
      };
    default:
      return state;
  }
};

export default authReducer;
